<template>
    <div class="card row cardBemVindo">
        <div class="col-12">
            <h4>{{ $t('Placas com OS Externas') }}</h4>
            <!-- <p>Atendimentos externos nos últimos 30 dias</p> -->
            <table class="table table-responsive" style="height: 410px; overflow: auto!important;">
                <thead>
                    <tr>
                        <th scope="col">{{ $t('Placa') }}</th>
                        <th scope="col">{{ $t('Data') }}</th>
                        <th scope="col-3">{{ $t('Fornecedor') }}</th>
                        <th scope="col">{{ $t('Segmento') }}</th>
                        <th scope="col">{{ $t('Problema') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(placa, index) in getPlacasExternas" :key="index">
                        <th scope="row">{{ placa.nr_placa }}</th>
                        <td>{{ placa.dt_os | formatDate("DD/MM/YYYY HH:mm:ss") }}</td>
                        <td>{{ placa.ds_fornecedor }}</td>
                        <td>{{ placa.segmento }}</td>
                        <td>{{ placa.problema }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },

  computed: {
    getPlacasExternas(){
        const placas =  this.$store.getters['dashboard/getPlacasExternas'];
        
        if(!placas){
            this.$store.dispatch('dashboard/getPlacasExternas')

            return []
        }
        return placas.placas_externas
    }
  },

  mounted() {
    this.$store.dispatch('dashboard/getPlacasExternas')
  },

  methods: {
    
  }
}
</script>
<style scoped>
    .cardBemVindo {
        flex-direction: row;
        align-items: flex-end;
        margin-right: 10px;
    }

    canvas {
        height: 400px;
        /* Define a altura fixa para o gráfico */
        width: 100%;
        /* Ocupar toda a largura disponível */
    }
</style>